export const rolePermissions = {
  admin: [
    "users/activate/:uuid/:token",
    "users/update-password/:uuid/:token",
    "validate",
    "transaction/all",
    "transaction/:transaction_id/:transaction_name",
    "vp/category",
    "vp/check/:category_id/:category_name",
    "vp/qrcode/:category_name/:check_id",
    "vp/result/:vp_instance_id",
    "settings",
    "profile",
    "validate/legacy/:certificate_id",
    "validate/:credential_id",
    "legacy/certificate-details",
    "legacy/user-details",
    "legacy/payment-details/:transaction_id",
    "legacy/summary",
    "vc/payment-details/:transaction_id/:order_id",
    "vc/summary",
    "ocr/summary",
    "validate/transaction/:transaction_id",
    "ocr/processing",
    "ocr/form",
    "ocr/payment-details/:transaction_id/:order_id",
  ],
  admin_verifier: [
    "users/activate/:uuid/:token",
    "users/update-password/:uuid/:token",
    "validate",
    "transaction/all",
    "transaction/:transaction_id/:transaction_name",
    "settings",
    "profile",
    "validate/legacy/:certificate_id",
    "validate/:credential_id",
    "legacy/certificate-details",
    "legacy/user-details",
    "legacy/payment-details/:transaction_id",
    "legacy/summary",
    "vc/payment-details/:transaction_id/:order_id",
    "vc/summary",
    "ocr/summary",
    "validate/transaction/:transaction_id",
    "ocr/processing",
    "ocr/form",
    "ocr/payment-details/:transaction_id/:order_id",
  ],
  verifier: [
    "users/activate/:uuid/:token",
    "users/update-password/:uuid/:token",
    "validate",
    "transaction/all",
    "transaction/:transaction_id/:transaction_name",
    "settings",
    "profile",
    "validate/legacy/:certificate_id",
    "validate/:credential_id",
    "legacy/certificate-details",
    "legacy/user-details",
    "legacy/payment-details/:transaction_id",
    "legacy/summary",
    "vc/payment-details/:transaction_id/:order_id",
    "vc/summary",
    "ocr/summary",
    "validate/transaction/:transaction_id",
    "ocr/processing",
    "ocr/form",
    "ocr/payment-details/:transaction_id/:order_id",
  ],
  admin_requester: [
    "users/activate/:uuid/:token",
    "users/update-password/:uuid/:token",
    "vp/category",
    "vp/check/:category_id/:category_name",
    "vp/qrcode/:category_name/:check_id",
    "vp/result/:vp_instance_id",
    "settings",
    "profile",
  ],
};

export default rolePermissions;
